import React from 'react';

export function H6({content, className}) {
    return (
        <h6 className={className}>{content}</h6>
    )
}